import Styles from "./index.module.scss";

const ErrorMsg = (props:any) => {
    const { fieldName, error, additionalClass='' } = props;
    return (
        <div id={`${fieldName}_error`} className={Styles.errorMessage} dangerouslySetInnerHTML={{__html: error}}></div>
    )
}
export default ErrorMsg;
